import React from "react";
import Seo from "../../../shared/ui/Seo";

const PrivacyPolicy = () => {
  return (
    <div className="container container-lg py-24">
      <Seo
        title="Privacy Policy"
        description="Read Bigmall's privacy policy and terms of use to see how we collect, use and protect your personal information when you shop online with us."
      />
      <h1 className="page-title">Privacy Policy & Terms of Use</h1>

      <section className="mb-4">
        <h6 className="fw-bold">INTRODUCTION</h6>
        <p>
          Welcome to Bigmall, Sri Lanka’s most prominent online shop. This is the content of these terms, stipulating the laws and limitations for use of Bigmall’s website and products. That is why, by accessing this website and utilizing our services, you agree to be bound by all terms of this agreement unconditionally. If you cannot respect all these terms and conditions, please do not use our website.
        </p>
        <p>
          Bigmall provides a great range of products and services for you in order for your online shopping to be both pleasurable and happy. Moreover, it ensures secure payments and offers high-quality customer support. These T&Cs cover your visits to our website and use of our services which include browsing, shopping and other interactions on our website.
        </p>
        <p>Thank you for choosing Bigmall. Happy shopping!</p>
      </section>

      <section className="mb-4">
        <h6 className="fw-bold">ACCEPTANCE OF TERMS OF USE</h6>
        <p>
          Accessing or employing the Bigmall website or the services offered by the same is deemed acceptance to be bound by the subsequent terms and conditions upon the Site. In case you do not agree with some of these terms, please be discontinued.
        </p>
      </section>

      <section className="mb-4">
        <h6 className="fw-bold">DETAILS WE COLLECT</h6>
        <p>
          When a user registers an account on Bigmall we collect the necessary personal data i.e., name, email address, phone number, or delivery address to support account management, order processing, and other.
        </p>
        <p>
          Bigmall is dedicated to maintaining customer’s privacy. It also ensures secrecy concerning personal information of individuals. It is worth noting that we do not process clients’ personal information for promoting, advertising purposes, and any other unauthorized needs without prior consent.
        </p>
        <p>
          Our topmost consideration is safety, as we comply with Sri Lankan data protection Act. Big Mall ensures that it maintains confidentiality of user’s information by not sending their details or selling them to other parties.
        </p>
      </section>

      <section className="mb-4">
        <h6 className="fw-bold">ORDER ELIGIBILITY</h6>
        <p>
          Users must fulfil the following eligibility conditions to make orders on Bigmall’s website: in Sri Lanka, persons should be of legal age or have parents/guardians consent. Additionally, users should provide valid payment and shipping details. By placing an order, users confirm their eligibility.
        </p>
      </section>

      <section className="mb-4">
        <h6 className="fw-bold">ORDER WARRANTY CLAIMS</h6>
        <p>
          Bigmall operates with a noted Disclaimer of Warranty, but we honor our assertion as per stated guarantee claims clearly noted in the respective product descriptions.
        </p>
      </section>

      <section className="mb-4">
        <h6 className="fw-bold">WARRANTY ADHERENCES</h6>
        <p>
          Where a product’s description includes warranty terms, buyers should research coverage, conditions, etc. Bigmall fully adheres to these terms.
        </p>
        <p>
          <strong>Duration and Limits:</strong> Some warranties have product-specific limitations. Please read the product's warranty terms to understand what is covered.
        </p>
        <p>
          <strong>Problem resolution:</strong> For any warranty-related issues, contact Bigmall customer service. We strive to resolve customer concerns fairly.
        </p>
      </section>

      <section className="mb-4">
        <h6 className="fw-bold">DATA DELETION</h6>
        <p>
          Customers have the right to request the deletion of their account and data. To do so, email us at <a href="mailto:info@bigmall.lk">info@bigmall.lk</a>. Once requested, your data will be securely deleted in compliance with applicable laws.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
